

import React from "react";
import Tiltphone from "../Images/Branding/Tiltphone.png";
import Biddocument from "../Images/Features/Biddocument.png";

const Brandinghero = () => {
	return (
		<div className="text-center">
			<div className="container brandingsection branding-container">
				<div className="row align-items-center">
					<div className="col-md-6 heroimg">
						<div className="text-left">
							<h1 className="display-5 lilitaoneblack mb-3">
								Property Maintenance & Renovation Made Easy:
							</h1>
							<h1 className="display-3 lilitaoneblack2 mb-4">
								find, hire, & manage service pros
							</h1>
							<p className="mb-4" style={{fontSize: '16px', lineHeight: '1.6'}}>
								Streamline the renovation and maintenance process
								for your investment property. Submit work orders,
								sign contracts, and schedule services hassle-free.
								Stay in the loop with progress updates, receive
								invoices, and remit payments –{" "}
								<strong>all in one place.</strong>
							</p>
							<div className="mb-4">
								<img className="biddocument img-fluid" src={Biddocument} alt="Bid Document" />
							</div>
							<h2 className="lilitaonered">
								Always Here, Always Redi
							</h2>
						</div>
					</div>
					<div className="col-md-6 brandingvalueprop">
						<div className="text-center">
							<img className="phonetilt img-fluid" src={Tiltphone} alt="Phone Mockup" style={{maxWidth: '100%', height: 'auto'}} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Brandinghero;